<script>

    import { toast } from 'bulma-toast'
    import { userStore, prepaidsStore, modalStore } from '../stores'

    import PrepaidsService from '../$services/prepaids.service.js'
    import Providers from '../$components/providers.svelte'
    import Date from '../$components/date.svelte'

    import Form from '../$components/form.svelte'

    import InputText from '../$components/input.text.svelte'
    import InputNumber from '../$components/input.number.svelte'

    import Button from '../$components/button.svelte'
    import ButtonSave from '../$components/button.save.svelte'

    export let type = 'global'

    let data = {}
    let loading = false

    async function createPrepaid() {

        data.userId = $userStore._id
        data.type = type

        loading = true
        const resp = await PrepaidsService.createPrepaid(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        prepaidsStore.append(resp.data)
        toast({message: 'Prepago creado', type: 'is-success'})
        
        modalStore.close()
    }
    
</script>

<Form on:submit={createPrepaid} { loading }>

    <Providers bind:provider={data.provider} bind:service={data.service} />

    <div class="columns">
        <div class="column">
            <InputText bind:value={data.volumetricMin} label="Peso mínimo" placeholder="Peso mínimo (kg)" />
        </div>
        <div class="column">
            <InputText bind:value={data.volumetricMax} label="Peso máximo" placeholder="Peso máximo (kg)" />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.shipmentPrice} step="0.01" label="Precio de envío" placeholder="Precio de envío" />
        </div>
        <div class="column">
            <InputNumber bind:value={data.shipmentsTotal} label="Cantidad de guías" placeholder="Cantidad de guías" />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.coverageCost} step="0.01" label="Cobertura costo" placeholder="Cobertura costo" />
        </div>
        <div class="column">
            <InputNumber bind:value={data.coverageSpecial} step="0.01" label="Cobertura especial" placeholder="Cobertura especial" />
        </div>
    </div>

    <Date bind:value={data.expired} label="Fecha de expiración" />

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Button on:click={modalStore.close} text="Cancelar" icon="ban" />
        <ButtonSave icon="plus" text="Crear" { loading } />
    </div>

</Form>